export default "__VITE_ASSET__f1fd7a97__"